// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__sVNFX","threshold":"styles_threshold__NXjVW"};